const styles = {
  container: {
    padding: '30px',
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    fontFamily: 'Segoe UI, sans-serif',
  },
  header: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.5rem',
    textAlign: 'center',
  },
  hr: {
    width: '80px',
    border: '2px solid #1B019B',
    opacity: '1',
    margin: '10px auto',
  },
  organisationHeader: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '15px',
  },
  actionButtonsContainer: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  createButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.95rem',
  },
  createAbsenceButton: {
    backgroundColor: '#1B019B',
    color: '#fff',
  },
  createRetardButton: {
    backgroundColor: '#FF8C00',
    color: '#fff',
  },
  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '20px',
    padding: '15px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  filterLabel: {
    fontSize: '0.85rem',
    color: '#666',
    fontWeight: '500',
    whiteSpace: 'nowrap',
  },
  dateInput: {
    borderRadius: '20px',
    padding: '8px 12px',
    fontSize: '0.9rem',
    border: '1px solid #ddd',
    minWidth: '140px',
    height: '38px',
    backgroundColor: '#fff',
  },
  select: {
    borderRadius: '20px',
    padding: '7px 12px',
    fontSize: '0.9rem',
    border: '1px solid #ddd',
    minWidth: '160px',
    height: '38px',
    backgroundColor: '#fff',
  },
  searchWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  searchInput: {
    borderRadius: '20px',
    padding: '8px 12px 8px 35px',
    fontSize: '0.9rem',
    border: '1px solid #ddd',
    minWidth: '180px',
    height: '38px',
    backgroundColor: '#fff',
  },
  searchIcon: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#6c757d',
  },
  resetButton: {
    height: '38px',
    padding: '0 20px',
    borderRadius: '20px',
    border: '1px solid #ddd',
    backgroundColor: '#f8f9fa',
    color: '#666',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '0.9rem',
    transition: 'all 0.2s',
  },
  tabsContainer: {
    display: 'flex',
    gap: '5px',
    marginBottom: '20px',
    backgroundColor: '#fff',
    padding: '5px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  tab: {
    padding: '10px 25px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'transparent',
    color: '#666',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.9rem',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  tabActive: {
    backgroundColor: '#1B019B',
    color: '#fff',
  },
  tabBadge: {
    backgroundColor: 'rgba(0,0,0,0.08)',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
  tabBadgeActive: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: '#fff',
  },
  tableHeader: {
    backgroundColor: '#1B019B',
    color: '#fff',
  },

  // ═══════════ BADGES DE STATUT ═══════════
  badgeEnAttente: {
    backgroundColor: '#ffc107',
    color: '#000',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '500',
    display: 'inline-block',
  },
  badgeApprouvee: {
    backgroundColor: '#28a745',
    color: '#fff',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '500',
    display: 'inline-block',
  },
  badgeRefusee: {
    backgroundColor: '#dc3545',
    color: '#fff',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '500',
    display: 'inline-block',
  },
  badgeInconnu: {
    backgroundColor: '#6c757d',
    color: '#fff',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '500',
    display: 'inline-block',
  },

  // ═══════════ BADGES DE TYPE ═══════════
  badgeTypeAbsence: {
    backgroundColor: '#1B019B',
    color: '#fff',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '0.7rem',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  badgeTypeRetard: {
    backgroundColor: '#FF8C00',
    color: '#fff',
    padding: '3px 10px',
    borderRadius: '12px',
    fontSize: '0.7rem',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  // ═══════ FIN BADGES ═══════

  actionButtons: {
    display: 'flex',
    gap: '6px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  actionButton: {
    border: 'none',
    borderRadius: '6px',
    padding: '6px 10px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',
    fontSize: '0.85rem',
  },
  approveButton: {
    backgroundColor: '#28a745',
    color: '#fff',
  },
  refuseButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
  },
  editButton: {
    backgroundColor: '#007bff',
    color: '#fff',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
  },
  detailButton: {
    background: 'none',
    border: 'none',
    color: '#1B019B',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    fontWeight: '500',
    fontSize: '0.85rem',
  },
  fileLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 14px',
    border: '1px solid #1B019B',
    borderRadius: '6px',
    color: '#1B019B',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'all 0.2s',
    fontSize: '0.85rem',
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1060,
    padding: '20px',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    maxWidth: '550px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '15px',
    borderBottom: '2px solid #f0f0f0',
  },
  modalTitle: {
    color: '#1B019B',
    fontWeight: '600',
    fontSize: '1.2rem',
    margin: 0,
  },
  modalClose: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    color: '#999',
  },
  detailGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  detailItem: {
    padding: '10px 0',
    borderBottom: '1px solid #eee',
  },
  justificationText: {
    marginTop: '5px',
    padding: '10px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    maxHeight: '150px',
    overflowY: 'auto',
    wordBreak: 'break-word',
    fontSize: '0.9rem',
  },

  // ═══════════ PAGINATION ═══════════
  paginationButton: {
    backgroundColor: '#1B019B',
    color: 'white',
    border: 'none',
    margin: '0 2px',
    borderRadius: '5px',
    padding: '5px 12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.85rem',
  },
  paginationActive: {
    backgroundColor: '#0d0066',
    color: 'white',
  },
  paginationDisabled: {
    backgroundColor: '#e0e0e0',
    color: '#a0a0a0',
    cursor: 'not-allowed',
  },
  // ═══════ FIN PAGINATION ═══════

  typeSelector: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },
  typeOption: {
    flex: 1,
    padding: '12px',
    textAlign: 'center',
    borderRadius: '8px',
    border: '2px solid #e0e0e0',
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  typeOptionActive: {
    borderColor: '#1B019B',
    backgroundColor: '#f0edff',
    color: '#1B019B',
  },
  formGroup: {
    marginBottom: '15px',
  },
  formLabel: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '500',
    color: '#333',
    fontSize: '0.9rem',
  },
  formInput: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '0.9rem',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  },
  formSelect: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '0.9rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  formTextarea: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '0.9rem',
    minHeight: '80px',
    resize: 'vertical',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  },
  formFile: {
    width: '100%',
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '0.9rem',
    backgroundColor: '#fff',
  },
  formCheck: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
  },
  formCheckInput: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
  },
  formCheckLabel: {
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '20px',
    paddingTop: '15px',
    borderTop: '2px solid #f0f0f0',
  },
  submitButton: {
    backgroundColor: '#1B019B',
    color: '#fff',
    padding: '10px 30px',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  cancelButton: {
    backgroundColor: '#f8f9fa',
    color: '#666',
    padding: '10px 25px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  emptyState: {
    padding: '40px',
    textAlign: 'center',
    color: '#999',
  },
  loadingState: {
    padding: '40px',
    textAlign: 'center',
    color: '#666',
  },
  infoText: {
    fontSize: '0.85rem',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },

  // ═══════════ SÉLECTEUR EMPLOYÉ ═══════════
  employeeSelectorBox: {
    border: '2px solid #e8e4ff',
    borderRadius: '10px',
    padding: '15px',
    marginBottom: '15px',
    backgroundColor: '#faf9ff',
  },
  employeeSelectorTitle: {
    fontSize: '0.85rem',
    fontWeight: '600',
    color: '#1B019B',
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  employeeSearchInput: {
    width: '100%',
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '0.9rem',
    marginBottom: '8px',
    boxSizing: 'border-box',
  },
  employeeList: {
    maxHeight: '180px',
    overflowY: 'auto',
    border: '1px solid #eee',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
  employeeListItem: {
    padding: '10px 14px',
    cursor: 'pointer',
    borderBottom: '1px solid #f5f5f5',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'background 0.15s',
    fontSize: '0.9rem',
  },
  employeeListItemActive: {
    backgroundColor: '#f0edff',
    color: '#1B019B',
    fontWeight: '600',
  },
  selectedEmployeeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#e8e4ff',
    color: '#1B019B',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '0.85rem',
    fontWeight: '500',
  },
  // ═══════ FIN SÉLECTEUR EMPLOYÉ ═══════

  card: {
    borderRadius: '15px',
    border: 'none',
  },
};

export default styles;